export interface ConnectionSelfSignup {
  id: number;
  organization_name: string;
  contact_email: string;
  service_region: ServiceRegion;
  website: string;
  org_type: OrgType;
  org_type_desc?: string;
  application_notes?: string;
  approver_notes?: string;
  status?: ConnectionSelfSignupStatus;
  joined?: boolean;
  created_on_utc: string;
  updated_on_utc: string;
  recaptcha?: string;
  has_it_support?: boolean;
  connection_display_name?: string;
  connection_name?: string;
  connection_type?: ConnectionType;
}

export function getOrgTypeLabel(orgType: OrgType): string {
  switch (orgType) {
    case OrgType.CommunityDevelopmentFinancialInstitution:
      return 'Community Development Financial Institution';
    case OrgType.SmallBusinessLoanFund:
      return 'Small Business Loan Fund';
    case OrgType.CreditUnion:
      return 'Credit Union';
    case OrgType.Bank:
      return 'Bank';
    case OrgType.TechnicalAssistanceProvider:
      return 'Technical Assistance Provider';
    case OrgType.ImpactFundOrVentureFund:
      return 'Impact Fund or Venture Fund';
    case OrgType.ChamberOfCommerce:
      return 'Chamber of Commerce';
    case OrgType.GovernmentOrQuasiGovernmentEntity:
      return 'Government or Quasi-Government Entity';
    case OrgType.Other:
      return 'Other';
    default:
      return 'Unknown';
  }
}

export interface ServiceRegion {
  city: string[];
  county: string[];
  state: string[];
  zip_code: string[];
}

export enum OrgType {
  CommunityDevelopmentFinancialInstitution = 1,
  SmallBusinessLoanFund = 2,
  CreditUnion = 3,
  Bank = 4,
  TechnicalAssistanceProvider = 5,
  ImpactFundOrVentureFund = 6,
  ChamberOfCommerce = 7,
  GovernmentOrQuasiGovernmentEntity = 8,
  Other = 9,
}

export enum ConnectionSelfSignupStatus {
  Pending = 1,
  Approved = 2,
  Rejected = 3,
  Joined = 4,
  NotJoined = 5,
}

export interface ConnectionSelfSignupStatusCounts {
  status: ConnectionSelfSignupStatus;
  count: number;
}

export enum ConnectionType {
  Auth0 = 1,
  DH = 2,
}
